import React, { memo, useEffect, useState } from 'react';

import { MapMarkerAltSolidIcon } from '../../shared/icons/icons';

import { GET_SIGNED_STATIC_MAP_URL } from './graphql/static-map-queries';

import { useGraphQLClient } from '../../shared/hooks/hooks';

import { GeoPoint } from '../../shared/types/graphql-types';

import './static-map.scss';

interface Markers extends GeoPoint {
  isPitpass?: boolean;
}

interface StaticMapProps {
  apiKey?: string;
  centerPos: GeoPoint;
  className?: string;
  height: number;
  isMyStore: boolean;
  markers?: Array<Markers>;
  showCenterMarker?: boolean;
  width: number;
  zoom?: number;
}

function StaticMap(props: StaticMapProps) {
  const {
    apiKey = process.env.__GOOGLE_API_KEY__,
    centerPos = null,
    className = '',
    height = 350,
    isMyStore = false,
    markers: markersProp,
    showCenterMarker = true,
    width = 700,
    zoom
  } = props;

  const client = useGraphQLClient();
  const [signedMapUrl, setSignedMapUrl] = useState();

  function queryMapImage() {
    let markers = '';
    let query = `center=${centerPos?.latitude},${centerPos?.longitude}&size=${width}x${height}`;

    if (zoom) {
      query += `&zoom=${zoom}`;
    }

    if (markersProp) {
      markers = markersProp.reduce(
        (acc, m, idx) =>
          `${acc}&markers=icon:https://discounttire.scene7.com/is/image/discounttire/${
            m?.isPitpass ? 'PP' : 'Reg'
          }_StaticMapPin_${(idx + 1).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
          })}?fmt=png-alpha%7C${m?.latitude},${m?.longitude}`,
        ''
      );
    }

    return `https://maps.googleapis.com/maps/api/staticmap?${query}${markers}&key=${apiKey}`;
  }

  const unsignedMapUrl = centerPos && height && width ? queryMapImage() : null;

  useEffect(() => {
    (async function () {
      if (unsignedMapUrl) {
        const { data } = await client.query({
          query: GET_SIGNED_STATIC_MAP_URL,
          variables: {
            url: unsignedMapUrl
          }
        });

        if (data?.store.signStaticMapUrl) {
          setSignedMapUrl(data.store.signStaticMapUrl);
        }
      }
    })();
  }, [client, unsignedMapUrl]);

  let imgUrl;

  if (signedMapUrl) {
    imgUrl = signedMapUrl;
  }

  return (
    <div
      className={className}
      style={imgUrl ? { backgroundImage: `url(${imgUrl})` } : undefined}
      styleName="container"
    >
      {showCenterMarker && (
        <MapMarkerAltSolidIcon
          styleName={isMyStore ? 'my-store-marker' : 'marker'}
        />
      )}
    </div>
  );
}

export default memo(StaticMap);
